import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandPointUp } from '@fortawesome/pro-regular-svg-icons/faHandPointUp'

export const defaultTranslations = {
    pluginName: 'Buttons',
    pluginDescription: 'Add a button link',
}

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faHandPointUp} size="3x" />,
}
